import { Box, Grid, useMediaQuery } from '@material-ui/core'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import { Width } from '@ts/css'
import React from 'react'

import { Theme } from '../../lib/theming/Theme'
import TicketVariantContext, { TicketVariant } from '../../lib/TicketVariantContext'
import { BenefitAvailabilityItem, BenefitDescriptionItem, BenefitList } from '.'

const useStyles = makeStyles<Theme, BenefitsGridStyleProps>(({ breakpoints, spacing }) => ({
  itemGrid: {
    [breakpoints.up('md')]: {
      flexBasis: 0,
      flexGrow: 1,
      margin: spacing(0, 1, 0),
    },
    [breakpoints.up('lg')]: {
      margin: spacing(0, 1.25, 0),
    },
  },
  itemGridAlignmentHack: {
    height: 48,
  },
  labelGrid: ({ width }) => ({
    flexBasis: 'auto',
    flexGrow: 0,
    width,
  }),
  soldOut: {
    [breakpoints.down('md')]: {
      order: 1,
    },
  },
}))

export type Benefit = {
  code?: string | null
  description?: string | null
  id: string | null
  itemIds?: string[]
  title: string
}

export type BenefitsGridProps = {
  benefits: Benefit[]
  items: {
    dealId?: string | null
    id?: string
    variant: TicketVariant
  }[]
  labelsColumnWidth?: Width
}

type BenefitsGridStyleProps = {
  width: Width
}

const BenefitsGrid = ({ benefits, items, labelsColumnWidth = '22%' }: BenefitsGridProps) => {
  const classes = useStyles({ width: labelsColumnWidth })
  const { breakpoints } = useTheme<Theme>()
  const mdUp = useMediaQuery(breakpoints.up('md'))

  return (
    <Box pb={mdUp ? 10 : 0}>
      <Grid container>
        {mdUp && (
          <Grid item xs className={classes.labelGrid}>
            <BenefitList>
              {benefits.map(benefit => (
                <BenefitDescriptionItem
                  key={benefit.id}
                  className={classes.itemGridAlignmentHack}
                  detail={benefit.description}
                  title={benefit.title}
                />
              ))}
            </BenefitList>
          </Grid>
        )}

        {items.map(({ id, dealId, variant }) => (
          <Grid
            key={`${id || ''}${dealId ? `_${dealId}` : ''}`}
            item
            className={classes.itemGrid}
            md="auto"
            xs={12}
          >
            <TicketVariantContext.Provider value={{ variant }}>
              <BenefitList>
                {benefits.map(benefit => (
                  <BenefitAvailabilityItem
                    key={benefit.id}
                    className={classes.itemGridAlignmentHack}
                    included={id ? benefit?.itemIds?.includes(id) || false : false}
                  />
                ))}
              </BenefitList>
            </TicketVariantContext.Provider>
          </Grid>
        ))}
      </Grid>
    </Box>
  )
}

export default BenefitsGrid
